import { CommonModule } from '@angular/common';
import { Component, Input, forwardRef } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FileUploadComponent } from '../file-upload/file-upload.component';
import { AIService } from '../../services/ai.service';
import { ButtonModule } from 'primeng/button';
import { AccordionModule } from 'primeng/accordion';
import { CheckboxModule } from 'primeng/checkbox';

class uiOption {
  key: string;
  type: string;
  data?: string[];
  accept?: string;
  _busy?: boolean;
  _mode?: string;
}
@Component({
  selector: 'brt-ui-settings',
  standalone: true,
  templateUrl: './ui-settings.component.html',
  styleUrl: './ui-settings.component.scss',
  imports: [CommonModule, FormsModule, AccordionModule, FileUploadComponent, InputTextareaModule, InputTextModule, ButtonModule, CheckboxModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UiSettingsComponent),
      multi: true
    }
  ]
})
export class UiSettingsComponent {
  constructor(private aiService: AIService) { }

  keys: uiOption[] = [];
  @Input('keys') set _keys(keys: string[]) {
    this.keys = keys.map(key => {
      var parts = key.split(':');
      return { key: parts[0], type: parts[1] || 'input', data: parts.slice(2) };
    });
  }
  value: { [key: string]: string };

  writeValue(value: { [key: string]: string }) {
    this.value = value || {};
    // this.keys.push(...Object.keys(this.value).filter(key => !this.keys.find(k => k.key == key)).map(key => ({ key, type: 'input' })));
  }
  registerOnChange(fn: any) { this.onChange = fn; }
  registerOnTouched(fn: any) { this.onTouched = fn; }
  onChange = (_: any) => { };
  onTouched = () => { };

  onUpload(key: string, paths: string[]) {
    this.value[key] = paths[0];
    this.onChange(this.value);
  }

  @Input('file-bucket') fileBucket: string;
  @Input('business-id') businessId: string;

  async requestAI(item: uiOption) {
    if (item._busy) return;
    try {
      item._busy = true;
      if (item.data?.[0] == 'ai') {
        this.value[item.key] = await this.aiService.completion(item.data[1], item.data[2]);
        this.onChange(this.value);
      }
    } finally { delete item._busy; }
  }
}
